import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { INVESTORS_ACTION_TYPE } from '../actions';

const initialState = {};

const investorsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case INVESTORS_ACTION_TYPE.GET_INVESTORS:
        return payload || state;

      case INVESTORS_ACTION_TYPE.GET_INVESTORS_LIST:
        payload.forEach(item => {
          if (draft[item.investorId]) {
            draft[item.investorId] = item;
          }
        });
        break;

      case INVESTORS_ACTION_TYPE.CREATE_INVESTOR:
      case INVESTORS_ACTION_TYPE.EDIT_INVESTOR:
        draft[payload.investorId] = payload;
        break;

      case INVESTORS_ACTION_TYPE.DELETE_INVESTOR:
        delete draft[meta.investorId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default investorsReducer;
